import React, { useContext, useEffect, useState } from "react";
import StoreContext from "./Store/Context";
import moment from "moment";
import { NavLink as RRNavLink, Outlet } from "react-router-dom";
import { NavItem, Label, Nav, NavLink, Col, Row, Container } from "reactstrap";
import { dataDropdownTipo, folios_restantes, postDisplay } from "./Services";

const Layout = ({ children }) => {
  const {
    token,
    cajaData,
    usr_key_login,
    dataCompania,
    usr_nombre,
    usr_perfil,
    usr_ajustes,
    usr_factura,
    usr_inventario,
    usr_cotizacion,
    usr_articulo,
    usr_reporte,
    usr_gastos,
    usr_clientes,
    quitToken,
  } = useContext(StoreContext);
  const [dataFolios, setDataFolios] = useState([]);
  var perfil = dataDropdownTipo.filter((data) => {
    if (data.value === usr_perfil) {
      return data.label;
    }
  });
  if (!token) {
    document.location.href = "/";
  }
  if (cajaData === undefined) {
    document.location.href = "/";
  }

  async function fetchFolios() {
    var response = await folios_restantes();
    setDataFolios(response.FoliosRestantesResult);
  }
  if (dataCompania && dataCompania.ini_fecha) {
    {
      moment(dataCompania.ini_fecha).format("YYYY-MM-DD");
    }
  }

  useEffect(() => {
    fetchFolios();
    postDisplay();
  }, []);
  if (token === "") {
    return null;
  } else {
    return (
      <React.Fragment>
        <Container fluid className="dashboard-home">
          <Row className="align-items-center mt-2">
            <Col xs={12} md={6}>
            <div className="info-card p-3">
              <h3 className="fw-bold text-black">
                <span className="text-red">MTC</span> SOFTWARE
              </h3>
              <p className="text-muted fs-7 text-black">Sistema de Gestión Empresarial</p>
            </div>
            
             
            </Col>

            <Col xs={12} md={6}>
            <div className="info-card info-card-movile p-2" >
              <div className="info-card p-2 d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <div className="icon-box">
                    <i className="bi bi-calendar3"></i>
                  </div>
                  <div>
                    <small className="fw-bold text-muted">Fecha de folios</small>
                    <div className="text-blue text-center">
                      {dataFolios !== undefined ? dataFolios.fechaLicencia : ""}
                    </div>
                  </div>
                </div>

                <div className="border-start ps-4">
                  <small className="fw-bold text-muted">Folios disponibles</small>
                  <div className="text-blue fs-4 text-center">
                    {dataFolios !== undefined ? dataFolios.foliosTotalesDisponibles : ""}
                  </div>
                </div>
              </div>
            </div>

            </Col>
          </Row>

          <Row className="g-3 justify-content-start mt-2">
            {usr_perfil === "1" ? (
              <Col className="btn-layout mt-2 btn-reporte_x2" xs={6} sm={4} md={4} lg={3} xl={2}>
                <NavItem className="text-center maker-none">
                  <NavLink tag={RRNavLink} to="/user/company" className="font-w-bold  menu-l">
                    <div className="module-card">
                      <img src="https://cdn-icons-png.flaticon.com/512/619/619034.png" alt="COMPAÑÍA" />
                      <h6>COMPAÑÍA</h6>
                      <p>Gestión de la compañía.</p>
                      <div className="line"></div>
                    </div>
                  </NavLink>
                </NavItem>
              </Col>
            ) : null}

            {usr_ajustes === "1" ? (
              <Col className="btn-layout mt-2 btn-reporte_x2" xs={6} sm={4} md={4} lg={3} xl={2}>
                <NavItem className="text-center maker-none">
                  <NavLink tag={RRNavLink} to="/user/configuracion" className="font-w-bold  menu-l">
                    <div className="module-card">
                      <img src="https://cdn-icons-png.flaticon.com/512/2099/2099058.png" alt ="CONFIGURACIÓN"/>
                      <h6>CONFIGURACIÓN</h6>
                      <p>Administración de configuraciones.</p>
                      <div className="line"></div>
                    </div>
                  </NavLink>
                </NavItem>
              </Col>
            ) : null}

            {usr_factura === "1" ? (
              <Col className="btn-layout mt-2 btn-reporte_x2" xs={6} sm={4} md={4} lg={3} xl={2}>
                <NavItem className="text-center maker-none">
                  <NavLink tag={RRNavLink} to="/user/factura" className="font-w-bold  menu-l">
                    <div className="module-card">
                      <img src="https://cdn-icons-png.flaticon.com/512/891/891462.png"  alt="FACTURA"/>
                      <h6>FACTURA</h6>
                      <p>Gestión de facturación.</p>
                      <div className="line"></div>
                    </div>
                  </NavLink>
                </NavItem>
              </Col>
            ) : null}
            {usr_inventario === "1" ? (
              <Col className="btn-layout mt-2 btn-reporte_x2" xs={6} sm={4} md={4} lg={3} xl={2}>
                <NavItem className="text-center maker-none">
                  <NavLink tag={RRNavLink} to="/user/inventario" className="font-w-bold  menu-l">
                    <div className="module-card">
                      <img src="https://cdn-icons-png.flaticon.com/512/2921/2921222.png" alt ="CONTROL DE INVENTARIO" />
                      <h6>CONTROL DE INVENTARIO</h6>
                      <p>Control de inventario.</p>
                      <div className="line"></div>
                    </div>
                  </NavLink>
                </NavItem>
              </Col>
            ) : null}
            {usr_cotizacion === "1" ? (
              <Col className="btn-layout mt-2 btn-reporte_x2" xs={6} sm={4} md={4} lg={3} xl={2}>
                <NavItem className="text-center maker-none">
                  <NavLink tag={RRNavLink} to="/user/cotizacion" className="font-w-bold  menu-l">
                    <div className="module-card">
                      <img src="https://cdn-icons-png.flaticon.com/512/2991/2991112.png" alt=""/>
                      <h6>COTIZACIONES</h6>
                      <p>Creación y gestión de cotizaciones.</p>
                      <div className="line"></div>
                    </div>
                  </NavLink>
                </NavItem>
              </Col>
            ) : null}

            {usr_clientes === "1" ? (
              <Col className="btn-layout mt-2 btn-reporte_x2" xs={6} sm={4} md={4} lg={3} xl={2}>
                <NavItem className="text-center maker-none">
                  <NavLink tag={RRNavLink} to="/user/clientes" className="font-w-bold  menu-l">
                    <div className="module-card">
                      <img src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"  alt="CLIENTES"/>
                      <h6>CLIENTES</h6>
                      <p>Administración de clientes.</p>
                      <div className="line"></div>
                    </div>
                  </NavLink>
                </NavItem>
              </Col>
            ) : null}

            {usr_articulo === "1" ? (
              <Col className="btn-layout mt-2 btn-reporte_x2" xs={6} sm={4} md={4} lg={3} xl={2}>
                <NavItem className="text-center maker-none">
                  <NavLink tag={RRNavLink} to="/user/articulos" className="font-w-bold  menu-l">
                    <div className="module-card">
                      <img src="https://cdn-icons-png.flaticon.com/512/679/679922.png" alt="ARTÍCULOS"/>
                      <h6>ARTÍCULOS</h6>
                      <p>Gestión de artículos y productos.</p>
                      <div className="line"></div>
                    </div>
                  </NavLink>
                </NavItem>
              </Col>
            ) : null}
            {usr_reporte === "1" ? (
              <Col className="btn-layout mt-2 btn-reporte_x2" xs={6} sm={4} md={4} lg={3} xl={2}>
                <NavItem className="text-center maker-none">
                  <NavLink tag={RRNavLink} to="/user/reporte" className="font-w-bold  menu-l">
                    <div className="module-card">
                      <img src="https://cdn-icons-png.flaticon.com/512/2920/2920322.png" alt="REPORTES"/>
                      <h6>REPORTES</h6>
                      <p>Generación de reportes e informes.</p>
                      <div className="line"></div>
                    </div>
                  </NavLink>
                </NavItem>
              </Col>
            ) : null}

            {usr_gastos === "1" ? (
              <Col className="btn-layout mt-2 btn-reporte_x2" xs={6} sm={4} md={4} lg={3} xl={2}>
                <NavItem className="text-center maker-none">
                  <NavLink tag={RRNavLink} to="/user/gastos" className="font-w-bold  menu-l">
                    <div className="module-card">
                      <img src="https://cdn-icons-png.flaticon.com/512/3135/3135706.png" alt="CUENTAS POR COBRAR"/>
                      <h6>CUENTAS POR COBRAR</h6>
                      <p>Cuentas por cobrar.</p>
                      <div className="line"></div>
                    </div>
                  </NavLink>
                </NavItem>
              </Col>
            ) : null}

            <Col className="btn-layout mt-2 reporte_x2" xs={6} sm={4} md={4} lg={3} xl={2}>
              <NavItem
                className="text-center maker-none"
                onClick={() => {
                  quitToken();
                  document.location.href = "/";
                }}
              >
                <NavLink className="font-w-bold  menu-l">
                 <div class="module-card">
                    <img src="https://cdn-icons-png.flaticon.com/512/1828/1828490.png" alt="SALIR" />
                    <h6>SALIR</h6>
                    <p>Cerrar sesión del sistema.</p>
                    <div class="line"></div>
                  </div>
                </NavLink>
              </NavItem>
            </Col>
          </Row>

          <Row className="g-3 mt-1">
            <Col  xs={12} sm={12} md={9} lg={9} xl={9} >
              <div className="info-card p-3 d-flex justify-content-around align-items-center">
                <div className="icon-box">
                  <i className="bi bi-person"></i>
                </div>
                <div>
                  <small className="fw-bold text-muted">Vendedor</small>
                  <div className="text-blue">{usr_nombre}</div>
                </div>
                <div className="border-start ps-4">
                  <small className="fw-bold text-muted">Caja</small>
                  <div className="text-blue">
                    {" "}
                    {cajaData !== undefined ? cajaData.caj_descripcion : ""}{" "}
                  </div>
                </div>
                <div className="border-start ps-4">
                  <small className="fw-bold text-muted">Punto facturación</small>
                  <div className="text-blue">
                    {" "}
                    {cajaData !== undefined ? cajaData.caja_punto_facturacion : ""}{" "}
                  </div>
                </div>
                <div className="border-start ps-4">
                  <small className="fw-bold text-muted">Licencia</small>
                  <div className="text-blue">
                    {dataFolios !== undefined ? dataFolios.licencia : ""}
                  </div>
                </div>
              </div>
            </Col>

            <Col xs={12} sm={12} md={3} lg={3} xl={3} >
              <div className="info-card p-3 d-flex justify-content-around align-items-center">
                <div className="icon-box">
                  <i className="bi bi-calendar3"></i>
                </div>
                <div>
                  <small className="fw-bold text-muted">Caducidad de licencia</small>
                  <div className="text-blue">{moment(dataCompania.ini_fecha).add(1, 'year').format("YYYY-MM-DD")}</div>
                </div>
                </div>
            </Col>
            <Col xs={12} sm={12} md={9} lg={9} xl={9} >
            <div className="info-card p-3 d-flex justify-content-around align-items-center">
            <strong className="text-black"> {dataCompania.com_nombre + " / " + dataCompania.com_alias + " / " + dataCompania.com_ruc + " DV "+dataCompania.com_dv}</strong><br></br><hr></hr>
            <strong className="text-black"> {dataCompania.com_direccion}</strong><hr></hr>
            {/* <p className="text-primary mb-0">
              <i className="bi bi-globe"></i> www.mtechnologypanama.com
            </p> */}
            </div>

          </Col>
          <Col xs={12} sm={12} md={3} lg={3} xl={3} className="mb-2" >
          <div  className="info-card p-1 d-flex justify-content-around align-items-center">
 <Outlet />
          </div>
             
          </Col>
          </Row>

          
        </Container>
      </React.Fragment>
    );
  }
};
export default Layout;
